import { render, staticRenderFns } from "./TopRecommendation.vue?vue&type=template&id=2c38d9e6&"
import script from "./TopRecommendation.vue?vue&type=script&lang=js&"
export * from "./TopRecommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports